import { render, staticRenderFns } from "./EiBookItem.vue?vue&type=template&id=663a43e4&scoped=true&"
import script from "./EiBookItem.vue?vue&type=script&lang=js&"
export * from "./EiBookItem.vue?vue&type=script&lang=js&"
import style0 from "./EiBookItem.vue?vue&type=style&index=0&id=663a43e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663a43e4",
  null
  
)

export default component.exports